import { setUser } from '@sentry/react'
import Cookies from 'js-cookie'
import { create } from 'zustand'

const ACCESS_TOKEN = 'access_token'
/** Shared cookie options for the access token.
 * - `secure`: only sent over HTTPS
 * - `sameSite: 'lax'`: sent on top-level navigations but not on cross-site sub-requests
 */
const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  secure: true,
  sameSite: 'lax',
}

export interface AuthState {
  isLogged: () => boolean
  getAccessToken: () => string | undefined
  setAccessToken: (accessToken: string) => void
  resetCredentials: () => void
}

export const useAuthStore = create<AuthState>()(() => ({
  isLogged: () => !!Cookies.get(ACCESS_TOKEN),
  getAccessToken: () => Cookies.get(ACCESS_TOKEN),
  setAccessToken: (accessToken: string) => {
    Cookies.set(ACCESS_TOKEN, accessToken, COOKIE_OPTIONS)
  },
  resetCredentials: () => {
    Cookies.remove(ACCESS_TOKEN)
    setUser(null)
  },
}))
